import { Component, Input } from "@angular/core";
import { iconsLibrary } from "../../../theme/constants";

@Component({
  selector: "cowing-core-coworking-confirm",
  templateUrl: "./coworking-confirm.component.html",
  styleUrls: ["./coworking-confirm.component.scss"],
})
export class CoworkingConfirmComponent {
  @Input("isCompany") isCompany = false;
  constructor() {}

  public get getImage() {
    return `${iconsLibrary["confirmImg"]}`;
  }
}
